Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'file-magnifying-glass';
var width = 384;
var height = 512;
var aliases = ['file-search'];
var unicode = 'f865';
var svgPathData =
  'M365.3 93.38l-74.63-74.64C278.6 6.742 262.3 0 245.4 0H64C28.65 0 0 28.65 0 64l.0065 384c0 35.34 28.65 64 64 64H320c35.2 0 64-28.8 64-64V138.6C384 121.7 377.3 105.4 365.3 93.38zM336 448c0 8.836-7.164 16-16 16H64.02c-8.838 0-16-7.164-16-16L48 64.13c0-8.836 7.164-16 16-16h160L224 128c0 17.67 14.33 32 32 32h79.1V448zM176 208c-53.02 0-96 42.98-96 96s42.98 96 96 96c17.77 0 34.21-5.16 48.48-13.58l46.55 46.55C275.7 437.7 281.8 440 288 440s12.28-2.344 16.97-7.031c9.375-9.375 9.375-24.56 0-33.94l-46.55-46.55C266.8 338.2 272 321.8 272 304C272 250.1 229 208 176 208zM176 352C149.5 352 128 330.5 128 304S149.5 256 176 256S224 277.5 224 304S202.5 352 176 352z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [width, height, aliases, unicode, svgPathData],
};

exports.faFileMagnifyingGlass = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;
